import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center pagination-container max-width" }
const _hoisted_2 = { class: "no-display" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_pagination, {
      density: "compact",
      modelValue: _ctx.page,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.page) = $event)),
      length: _ctx.totalPages,
      "total-visible": _ctx.visiblePages
    }, null, 8, ["modelValue", "length", "total-visible"]),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.page), 1)
  ]))
}